<ng-container *transloco="let t; read: 'data-table'">
  <p-table
    #dt
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    dataKey="id"
    responsiveLayout="scroll"
    sortMode="single"
    styleClass="p-datatable-gridlines p-datatable-striped"
    [columns]="selectedCols"
    [customSort]="true"
    [globalFilterFields]="globalFilterFields"
    [loading]="loading"
    [paginator]="true"
    [reorderableColumns]="true"
    [resizableColumns]="true"
    [rows]="50"
    [rowsPerPageOptions]="[25, 50, 100, 500]"
    [showCurrentPageReport]="true"
    [value]="tableRows | async"
    (onRowReorder)="onRowReorder(dt.value)"
    (sortFunction)="sortTable($event)"
  >
    <!-- Filters -->
    <ng-template pTemplate="caption">
      <legend *ngIf="title">{{ title }}</legend>
      <app-data-table-caption
        [actionsTemplate]="actionsTemplate"
        [cols]="cols"
        [download]="download"
        [refreshClicked]="refreshClicked"
        [rightActionsTemplate]="rightActionsTemplate"
        [table]="dt"
        [translationScope]="translationScope"
        [(selectedCols)]="selectedCols"
      >
      </app-data-table-caption>
    </ng-template>

    <!-- Header -->
    <ng-template *transloco="let dataScopedT; read: translationScope" let-columns pTemplate="header">
      <tr>
        <th *ngIf="expansionRow !== undefined" class="data-table__narrow-header"></th>
        <th *ngIf="rowReorderEnabled" class="data-table__row-reorder-header"></th>

        <ng-container *ngFor="let col of columns">
          <ng-container
            *ngIf="columnDefinitions[col.field]?.header as headerDefinition; else headerTranslation"
            [ngTemplateOutlet]="headerDefinition.templateRef"
          ></ng-container>
          <ng-template #headerTranslation>
            <th pReorderableColumn [pSortableColumn]="col.field">
              {{ dataScopedT(col.header) }}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </ng-template>
        </ng-container>

        <th *ngIf="rowIconButtons && rowIconButtons.length > 0" class="data-table__narrow-header"></th>
      </tr>
    </ng-template>

    <!-- Display Rows -->
    <ng-template
      *transloco="let unscopedT"
      let-columns="columns"
      let-expanded="expanded"
      let-rowData
      let-rowIndex="rowIndex"
      pTemplate="body"
    >
      <tr [ngClass]="rowData.alertType" [pReorderableRow]="rowIndex" [pReorderableRowDisabled]="!rowReorderEnabled">
        <td *ngIf="expansionRow !== undefined" class="ui-resizable-column">
          <a href="#" [pRowToggler]="rowData">
            <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
          </a>
        </td>
        <td *ngIf="rowReorderEnabled" class="ui-resizable-column data-table__row-reorder-cell">
          <button
            class="data-table__row-reorder-handle"
            pReorderableRowHandle
            type="button"
            [attr.aria-label]="unscopedT('data-table.rowReorderHandleLabel')"
          >
            <mat-icon pReorderableRowHandle aria-hidden="true">menu</mat-icon>
          </button>
        </td>

        <ng-container *ngFor="let col of columns">
          <ng-container
            *ngIf="columnDefinitions[col.field]?.cell as cellDefinition; else rowDataCell"
            [ngTemplateOutlet]="cellDefinition.templateRef"
            [ngTemplateOutletContext]="{ $implicit: rowData, rowIndex }"
          ></ng-container>
          <ng-template #rowDataCell>
            <td class="ui-resizable-column row-toggle-cursor" [pRowToggler]="rowData">
              <app-row-cell [col]="col" [rowData]="rowData"></app-row-cell>
            </td>
          </ng-template>
        </ng-container>

        <td *ngIf="rowIconButtons && rowIconButtons.length > 0" class="ui-resizable-column">
          <ng-container *ngFor="let button of rowIconButtons">
            <button
              class="p-button-rounded p-button-danger p-button-text"
              pButton
              type="button"
              (click)="onRowIconButtonClick(rowData, rowIndex, button.name)"
            >
              <i [class]="button.icon"></i>
            </button>
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <!-- Expansion -->
    <ng-template *ngIf="expansionRow !== undefined" let-columns="columns" let-rowData pTemplate="rowexpansion">
      <!--
        Note: index is intentionally omitted should not be trusted for looping over data
        Rows can be filtered and sorted, which would change the index of rows and can cause mismatch with expected index
        Instead, use rowData object to identify the row by a unique identifier
      -->
      <tr>
        <td [attr.colspan]="getColumnCount(columns)">
          <ng-container
            [ngTemplateOutlet]="expansionRow"
            [ngTemplateOutletContext]="{ $implicit: rowData, rowData: rowData }"
          ></ng-container>
        </td>
      </tr>
    </ng-template>

    <!-- Empty Message -->
    <ng-template let-columns pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="getColumnCount(columns)">
          {{ t('emptyMessage') }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-container>
